module.exports = __webpack_public_path__ + "static/media/badge.4c27598e.svg";